import { queryClient } from "~/repository";
import {
  ADD_NOTE_SUCCESS,
  EDIT_NOTE_SUCCESS,
  MOVE_NOTE_TO_TRASH_SUCCESS,
  RESTORE_NOTE_FROM_TRASH_SUCCESS,
} from "~/store/action_types";

const notebookMiddleware =
  ({ getState }) =>
  (next) =>
  (action) => {
    const { type, response } = action;

    switch (type) {
      case ADD_NOTE_SUCCESS:
      case MOVE_NOTE_TO_TRASH_SUCCESS:
      case RESTORE_NOTE_FROM_TRASH_SUCCESS:
      case EDIT_NOTE_SUCCESS: {
        if (response) {
          const { single = {} } = response;
          const { notebook_id, id } = single;
          if (notebook_id > 0) {
            queryClient.invalidateQueries(["notebooks"]);
          } else if (getState()?.notes[id]?.notebook_id > 0 && notebook_id === 0) {
            queryClient.invalidateQueries(["notebooks"]);
          }
        }
        return next(action);
      }
      default:
        return next(action);
    }
  };

export default notebookMiddleware;
